import { action, observable, flow, makeObservable } from "mobx";
import TbSysPop from "domain/main/sys/pop/TbSysPop";
import mainPopupRepository from "../repository/MainPopupRepository";

class MainPopupStore {
  popups: TbSysPop[] = [];
  isLoaded: boolean = false;

  public constructor(pagePopup?: TbSysPop[]) {
    if(pagePopup)
      this.popups = pagePopup;
    makeObservable(this, {
      popups: observable,
      isLoaded: observable,
      setPopups: action,
      readPopups: flow
    });
  }

  setPopups(popups: TbSysPop[]) {
    this.popups = popups;
  }

  *readPopups() {
    this.popups = yield mainPopupRepository.get();
    this.isLoaded = true;
  }
}
const mainPopupStore = new MainPopupStore();
export default mainPopupStore;